import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss']
})
export class ImageEditorComponent implements OnInit {

  @ViewChild('imageCropper', { static: true }) imageCropper: ImageCropperComponent;

  imgBrilho = 100;
  imgContraste = 100;
  imgElement = null;

  maintainAspectRatio = true;
  aspectRatio = 4 / 3;

  @Input() autoCrop = false;
  @Input() imageBase64:string = null;
  @Output() imageBase64Change = new EventEmitter();

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.imgElement = document.querySelector('image-cropper .source-image') as HTMLElement;
  }

  ngOnDestroy() {
    console.error('image editor n ecsiste mais');
  }

  setImageStyle() {
    this.imgElement.setAttribute('style', 'filter: brightness(' + this.imgBrilho + '%) contrast(' + this.imgContraste + '%)');
  }

  savarFiltro() {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    let img = new Image();
    img.src = this.imageBase64;
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.filter = 'brightness(' + this.imgBrilho + '%) contrast(' + this.imgContraste + '%)';
      ctx.drawImage(img, 0, 0);
      this.imageBase64 = canvas.toDataURL('image/jpeg');
      this.imageBase64Change.emit(this.imageBase64);
      this.cd.markForCheck();
    };
  }

  async crop() {
    await this.imageCropper.crop();
  }

  imageCropped(event: ImageCroppedEvent) {
    this.imageBase64 = event.base64;
    if (this.imgContraste != 100 || this.imgBrilho != 100) {
      this.savarFiltro();
    } else {
      this.imageBase64Change.emit(this.imageBase64);
      this.cd.markForCheck();
    }
  }

  imageLoaded() {
    console.info('loaded');
  }
  cropperReady() {
    console.info('ready');
  }
  loadImageFailed(e) {
    console.error('falhou', e);
  }
  rotateLeft() {
    this.imageCropper.rotateLeft();
  }
  rotateRight() {
    this.imageCropper.rotateRight();
  }
  flipHorizontal() {
    this.imageCropper.flipHorizontal();
  }
  flipVertical() {
    this.imageCropper.flipVertical();
  }

}
